import { render, staticRenderFns } from "./BriqDurationInput.vue?vue&type=template&id=20f46662&lang=pug&"
import script from "./BriqDurationInput.vue?vue&type=script&lang=js&"
export * from "./BriqDurationInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqDurationInput.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports